import { Components, listItemButtonClasses, Theme } from '@mui/material';

export const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          '&:hover': {
            backgroundColor: theme.palette.background.surface.hover,
            color: theme.palette.text.default,
          },
          [`&.${listItemButtonClasses.selected}`]: {
            backgroundColor: theme.palette.background.surface.selected,
            color: theme.palette.text.default,
          },
          [`&.${listItemButtonClasses.selected}:hover`]: {
            backgroundColor: theme.palette.background.surface.hover,
            color: theme.palette.text.default,
          },
        };
      }

      return {};
    },
  },
};
